
(function () {
  'use strict';

  function t(key, fallback, vars) {
    return window.t ? window.t(key, fallback, vars) : fallback;
  }

  function money(cents) {
    return window.TwoLaneCart
      ? window.TwoLaneCart.formatMoney(cents)
      : '$' + (cents / 100).toFixed(2);
  }

  const FIELD_LABELS = {
    zip:      t('postal_code', 'Postal code'),
    country:  t('country', 'Country'),
    province: t('province', 'State / province')
  };

  function post(url, body, keepalive) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      keepalive: !!keepalive
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); });
  }

  const est = document.querySelector('[data-shipping-estimate]');
  if (est) {
    const countrySel  = est.querySelector('[data-estimate-country]');
    const provinceSel = est.querySelector('[data-estimate-province]');
    const zipInput    = est.querySelector('[data-estimate-zip]');
    const submit      = est.querySelector('[data-estimate-submit]');
    const result      = est.querySelector('[data-estimate-result]');

    Array.prototype.forEach.call(countrySel.options, function (o) {
      if (o.value === '---') { o.disabled = true; o.hidden = true; }
    });
    (function selectDefault() {
      const want = countrySel.dataset.default || '';
      const hit  = Array.prototype.find.call(countrySel.options, function (o) {
        return o.value === want || o.textContent.trim() === want;
      });
      if (hit) { countrySel.value = hit.value; return; }
      const first = Array.prototype.find.call(countrySel.options, function (o) { return o.value !== '---'; });
      if (first) countrySel.value = first.value;
    })();

    function syncProvinces() {
      const opt = countrySel.options[countrySel.selectedIndex];
      let provinces = [];
      try { provinces = JSON.parse(opt.getAttribute('data-provinces') || '[]'); } catch (e) { provinces = []; }

      provinceSel.innerHTML = '';
      if (!provinces.length) {
        provinceSel.hidden = true;
        return;
      }
      provinces.forEach(function (p) {
        const o = document.createElement('option');
        o.value = p[0];
        o.textContent = p[1];
        provinceSel.appendChild(o);
      });
      provinceSel.hidden = false;
    }

    countrySel.addEventListener('change', syncProvinces);
    syncProvinces();

    function renderRates(rates) {
      result.innerHTML = '';
      if (!rates.length) {
        const p = document.createElement('p');
        p.className = 'is-empty';
        p.textContent = t('estimate_none',
          'We do not ship to that address yet. Message us and we will see what we can do.');
        result.appendChild(p);
        return;
      }
      const ul = document.createElement('ul');
      rates.forEach(function (rate) {
        const li = document.createElement('li');
        const name = document.createElement('span');
        name.textContent = rate.name;
        const price = document.createElement('strong');
        price.textContent = money(Math.round(parseFloat(rate.price) * 100));
        li.appendChild(name);
        li.appendChild(price);
        ul.appendChild(li);
      });
      result.appendChild(ul);
    }

    submit.addEventListener('click', function () {
      const zip = (zipInput.value || '').trim();
      const country = countrySel.value;
      const province = provinceSel.hidden ? '' : provinceSel.value;

      submit.disabled = true;
      result.textContent = t('estimate_loading', 'Checking rates…');

      const qs = 'shipping_address[country]=' + encodeURIComponent(country) +
                 '&shipping_address[province]=' + encodeURIComponent(province) +
                 '&shipping_address[zip]=' + encodeURIComponent(zip);

      fetch('/cart/shipping_rates.json?' + qs, { credentials: 'same-origin' })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          submit.disabled = false;
          if (!res.ok) {
            const first = res.json && typeof res.json === 'object'
              ? Object.keys(res.json).map(function (k) {
                  return (FIELD_LABELS[k] || k) + ' ' + [].concat(res.json[k]).join(', ');
                })[0]
              : null;
            result.innerHTML = '';
            const p = document.createElement('p');
            p.className = 'is-error';
            p.textContent = first || t('estimate_error', 'Could not get rates for that address.');
            result.appendChild(p);
            return;
          }
          renderRates((res.json && res.json.shipping_rates) || []);
        })
        .catch(function () {
          submit.disabled = false;
          result.innerHTML = '';
          const p = document.createElement('p');
          p.className = 'is-error';
          p.textContent = t('estimate_error', 'Could not get rates right now.');
          result.appendChild(p);
        });
    });
  }

  document.querySelectorAll('[data-discount-field]').forEach(function (disc) {
    if (disc.dataset.discountBound) return;
    disc.dataset.discountBound = '1';
      const input  = disc.querySelector('[data-discount-input]');
      const apply  = disc.querySelector('[data-discount-apply]');
      const status = disc.querySelector('[data-discount-status]');

      function run() {
        const code = (input.value || '').trim();
        if (!code) return;

        status.classList.remove('is-error');
        status.textContent = t('discount_checking', 'Checking…');

        try { sessionStorage.setItem('2lane:dc', code); } catch (e) { /* no storage: no message */ }
        window.location.href = '/discount/' + encodeURIComponent(code) +
                               '?redirect=' + encodeURIComponent('/cart?dc=' + encodeURIComponent(code));
      }

      apply.addEventListener('click', run);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); run(); }
      });

      let tried = new URLSearchParams(window.location.search).get('dc');
      let mine = null;
      try { mine = sessionStorage.getItem('2lane:dc'); sessionStorage.removeItem('2lane:dc'); } catch (e) { /* ignore */ }
      if (tried && tried !== mine) {
        const stray = new URL(window.location.href);
        stray.searchParams.delete('dc');
        window.history.replaceState({}, '', stray.toString());
        tried = null;
      }
      if (tried) {
        const appliedCodes = Array.prototype.map.call(
          disc.querySelectorAll('.cart-discount__active strong'),
          function (el) { return el.textContent.trim().toLowerCase(); }
        );
        if (appliedCodes.indexOf(tried.toLowerCase()) === -1) {
          status.classList.add('is-error');
          const shown = tried.length > 40 ? tried.slice(0, 40) + '…' : tried;
          status.textContent = t('discount_invalid',
            '“' + shown + '” is not a valid code, or it does not apply to what is in your cart.',
            { CODE: shown });
        } else {
          status.textContent = '';
        }
        const url = new URL(window.location.href);
        url.searchParams.delete('dc');
        window.history.replaceState({}, '', url.toString());
      }
    });

  const prot = document.querySelector('[data-shipping-protection]');
  if (prot) {
    const toggle  = prot.querySelector('[data-protection-toggle]');
    const status  = prot.querySelector('[data-protection-status]');
    const variant = prot.dataset.variant;

    const offered = !!prot.closest('[data-protection-offered]');
    if (prot.dataset.defaultOn === '1' && !offered && !toggle.checked) {
      toggle.checked = true;
      addProtection(true);
    }

    function markOffered() {
      return post('/cart/update.js', { attributes: { _protection_offered: '1' } })
        .catch(function () { return null; });
    }

    function finish(msg, isError) {
      prot.classList.remove('is-busy');
      status.textContent = msg || '';
      status.style.color = isError ? '#C0392B' : '';
    }

    function addProtection(auto) {
      prot.classList.add('is-busy');
      return post('/cart/add.js', { items: [{ id: Number(variant), quantity: 1 }] })
        .then(function (res) {
          if (!res.ok) throw new Error((res.json && res.json.description) || 'add failed');
          return auto ? markOffered() : null;
        })
        .then(function () { window.location.reload(); })
        .catch(function (e) {
          toggle.checked = false;
          finish(String(e.message || e), true);
        });
    }

    function removeProtection() {
      prot.classList.add('is-busy');
      return post('/cart/change.js', { id: String(variant), quantity: 0 })
        .then(function (res) {
          if (!res.ok) throw new Error('remove failed');
          return prot.dataset.defaultOn === '1' ? markOffered() : null;
        })
        .then(function () { window.location.reload(); })
        .catch(function () {
          toggle.checked = true;
          finish(t('protect_error', 'Could not update that just now.'), true);
        });
    }

    toggle.addEventListener('change', function () {
      if (toggle.checked) addProtection(); else removeProtection();
    });
  }

  const note = document.querySelector('.pagenote [data-cart-note]');

  if (note) {
    const status = document.querySelector('[data-cart-note-status]');
    let last = note.value;
    let timer = null;

    function save(urgent) {
      if (note.value === last) return;
      last = note.value;
      post('/cart/update.js', { note: note.value }, urgent)
        .then(function () {
          if (!status) return;
          status.classList.add('is-saved');
          status.textContent = t('note_saved', 'Note saved.');
          setTimeout(function () {
            status.classList.remove('is-saved');
            status.textContent = '';
          }, 2500);
        })
        .catch(function () {
          if (status) status.textContent = t('note_error', 'Could not save that note.');
        });
    }

    note.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(save, 900);
    });
    note.addEventListener('blur', function () {
      clearTimeout(timer);
      save(true);
    });

    window.addEventListener('pagehide', function () {
      clearTimeout(timer);
      save(true);
    });
  }

})();
